import { AbstractListComponent } from './list.component';
import { Subject, Subscription } from 'rxjs';
import { EventBus, IEvent } from '../../event/bus';
import { ActivatedRoute, Router } from '@angular/router';
import { IConfirmationDialogPayload } from '../../ui/component/confirmation-dialog/confirmation-dialog-payload.interface';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AfterViewChecked, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { UrlBuilder } from '../api/url-builder';

export abstract class AbstractPresetListComponent extends AbstractListComponent implements OnInit, OnDestroy, AfterViewChecked {

  protected currentPreset: any;
  protected defaultSubject: Subject<IConfirmationDialogPayload> = new Subject();

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              urlBuilder: UrlBuilder,
              protected eventBus: EventBus,
              protected changeDetector: ChangeDetectorRef) {
    super(httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(): void {
    this.parameters.limit = 999;
    super.ngOnInit();

    this.eventBus.on('preset:loading').subscribe(
      (event: IEvent) => {
        this.loading = event.value[0];
      }
    );
    this.eventBus.on('preset:saved').subscribe(
      (event: IEvent) => {
        this.load();
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.defaultSubject.unsubscribe();
    this.eventBus.release();
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  makeDefault(id): Subscription {
    return this.httpClient.put(this.urlBuilder.buildUrl(this.getResourceUrl() + '/custom/' + id + '/default'), { isDefault: true })
      .subscribe(
        (response: any) => {
          this.load();
          this.toastrService.success('Saved');
        },
        (error: any) => {
          this.loading = false;
          this.toastrService.error('Failed to change default settings');
        }
      );
  }

  makeNonDefault(id): Subscription {
    return this.httpClient.put(this.urlBuilder.buildUrl(this.getResourceUrl() + '/custom/' + id + '/default'), { isDefault: false })
      .subscribe(
        (response: any) => {
          this.load();
          this.toastrService.success('Saved');
        },
        (error: any) => {
          this.loading = false;
          this.toastrService.error('Failed to change default settings');
        }
      );
  }

  makeActive(id): void {
    this.httpClient.put(this.urlBuilder.buildUrl(this.getResourceUrl() + '/custom/' + id + '/active'), { isActive: true })
      .subscribe(
        (response: any) => {
          this.load();
          this.toastrService.success('Saved');
        },
        (error: any) => {
          this.loading = false;
          this.toastrService.error('Failed to change active settings');
        }
      );
  }

  makeInActive(id): void {
    this.httpClient.put(this.urlBuilder.buildUrl(this.getResourceUrl() + '/custom/' + id + '/active'), { isActive: false })
      .subscribe(
        (response: any) => {
          this.load();
          this.toastrService.success('Saved');
        },
        (error: any) => {
          this.loading = false;
          this.toastrService.error('Failed to change active settings');
        }
      );
  }

  edit(row): void {
    this.currentPreset = row.id;
  }
}
